import { Box, IconButton, styled } from '@mui/material';

export const NOTE_CONTENT_SX = {
  mt: 1,
  fontSize: '0.875rem',
  lineHeight: 1.4,
  wordBreak: 'break-word',
  '& p': {
    my: 0,
  },
  '& p + p, & ul + p, & ol + p, & p + ul, & p + ol, & ul + ul, & ol + ol': {
    mt: 1,
  },
  '& ul, & ol': {
    margin: '8px 0 0',
    paddingLeft: '20px',
  },
  '& li': {
    marginBottom: '2px',
  },
  '& img': {
    display: 'block',
    maxWidth: '100%',
    maxHeight: 200,
    mt: 1,
    borderRadius: 1,
  },
  '& a': {
    color: 'primary.main',
  },
} as const;

export const NotesList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  overflowY: 'auto',
  maxHeight: 240,
}));

export const NoteCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(1.25),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
}));

export const NoteHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
});

export const NoteAuthorBlock = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
  flex: 1,
});

export const DeleteNoteButton = styled(IconButton)(({ theme }) => ({
  width: 28,
  height: 28,
  borderRadius: theme.spacing(0.75),
  flexShrink: 0,
  backgroundColor: theme.palette.action.hover,
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}));
